/**
 * @generated SignedSource<<fd17cbc3eb112ec01592f8c617516354>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedCreatorTopContent_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespContentModuleSelector_user">;
  readonly " $fragmentType": "SbSharedCreatorTopContent_user";
};
export type SbSharedCreatorTopContent_user$key = {
  readonly " $data"?: SbSharedCreatorTopContent_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedCreatorTopContent_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedCreatorTopContent_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespContentModuleSelector_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "4a6809b33c8207b8a0d0f3bdd7e61058";

export default node;
